var _rect, _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountingBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.9999,
    y: 8.00003,
    width: 8,
    height: 6,
    rx: 1.92857,
    stroke: "#2d2d2d",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92865 1.99998C6.31124 1.99998 5.00008 3.31115 5.00008 4.92856V16.0714C5.00008 17.6888 6.31124 19 7.92865 19H19.0715C20.6889 19 22.0001 17.6888 22.0001 16.0714V14.25V14H20.0001V14.25V16.0714C20.0001 16.5842 19.5843 17 19.0715 17H7.92865C7.41581 17 7.00008 16.5842 7.00008 16.0714V4.92856C7.00008 4.41572 7.41581 3.99998 7.92865 3.99998H19.0715C19.5843 3.99998 20.0001 4.41572 20.0001 4.92856V6.74998V8.00002H22.0001V6.74998V4.92856C22.0001 3.31115 20.6889 1.99998 19.0715 1.99998H7.92865Z",
    fill: "#2d2d2d"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 0.678571,
    fill: "#2d2d2d",
    stroke: "#2d2d2d",
    strokeWidth: 0.642857
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.99997V18.4285C3 19.8487 4.15127 21 5.57143 21H15",
    stroke: "#2d2d2d",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingBook);
export default __webpack_public_path__ + "static/media/accounting_book.e0be7e00b62c6ea47d9cddc63a80e60f.svg";
export { ForwardRef as ReactComponent };